function headerSearch() {
    var reset   = $('._js-search-reset'),
        button  = $('._js-search-button'),
        close   = $('._js-search-close'),
        trigger = $('._js-mobile-search-trigger'),
        search  = $('.header-search'),
        input   = $('._js-search__input');

    input.on('change keyup keydown focusin focusout', function(e){
        if ( $(this).val() != "" ) {
            search.addClass('_not-empty _found');
            if ( $(this).hasClass('_error') ) {
                $(this).removeClass('_error');
            }
        }
        else if (e.type === 'focusin' && $(this).val() != "" ) {
            search.addClass('_not-empty _found');
        }
        else if (e.type === 'focusout') {
            search.removeClass('_not-empty _found');
        }
        else {
            search.removeClass('_not-empty _found');
        }
    });

    button.on('click', function(e){
        if ( input.val() === "" ) {
            e.preventDefault();
            input.addClass('_error');
        }
    });

    reset.on('click', function(){
        input.val(null);
        search.removeClass('_not-empty _found');
    });

    close.on('click', function(){
        if ( search.hasClass('_visible') ) {
            input.val(null);
            search.removeClass('_not-empty _found _visible');
        }
    });

    trigger.on('click', function(){
        if ( !search.hasClass('_visible') ) {
            search.addClass('_visible');
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!search.is(e.target) && search.has(e.target).length === 0) {
            search.removeClass('_not-empty _found _visible');
        }
    });

}